/**
 * Registers a default filter for the given AngularJS module.
 * This filter returns the input value if it is defined, otherwise it returns the default value.
 * 
 * @param {object} module - The AngularJS module to register the filter with.
 */
export default function registerDefaultFilter(module) {
    module.filter('default', function() {
        return function(input, defaultValue) {
            // Check if the input is falsy (undefined, null, false, 0, NaN, or an empty string)
            if (!input) {
                // Return the default value if the input is falsy
                return defaultValue;
            }

            // Return the input value if it is defined
            return input;
        };
    });
}